import { useApp } from "@/context/AppContext";
import { TESTIMONIALS } from "@/lib/site";
import { Seo, PageHeader, CtaLink, SimDisclaimer } from "@/components/common";

export default function Results() {
  const { t } = useApp();
  const cases = [
    {
      title: { tr: "Renk ve form uyumsuzluğu — 8 diş zirkonyum planı", en: "Shade and form mismatch — 8-tooth zirconium plan" },
      story: {
        tr: "Almanya'dan gelen hastamız, eski kompozit restorasyonların renk uyumsuzluğu nedeniyle başvurdu. Dijital analizde dudak hattı ve yüz oranları incelendi; sekiz üst ön diş ayrı ayrı planlandı. Prova aşamasında hasta ile kenar geçirgenliği üzerine birlikte karar verildi. Tedavi 6 günde tamamlandı; hasta rutin uzaktan takip programına alındı.",
        en: "Our patient from Germany presented due to shade mismatch of old composite restorations. Digital analysis examined the lip line and facial proportions; the eight upper front teeth were planned individually. Edge translucency was decided together with the patient at the try-in stage. Treatment was completed in 6 days; the patient joined our routine remote follow-up programme.",
      },
    },
    {
      title: { tr: "Aşınmış kesici kenarlar — doğal form restorasyonu", en: "Worn incisal edges — natural form restoration" },
      story: {
        tr: "İsveç'ten gelen hastamızda yıllar içinde kısalmış ön dişler mevcuttu. Kapanış değerlendirmesi sonrası uygunluk onaylandı. Hedef, hastanın gençlik fotoğraflarındaki doğal diş formuna yaklaşmaktı; aşırı beyazlık özellikle tercih edilmedi. Yerleştirme öncesi dijital simülasyon hasta ile paylaşıldı.",
        en: "Our patient from Sweden had front teeth shortened over the years. Suitability was confirmed after a bite evaluation. The goal was to approach the natural tooth form seen in the patient's younger photos; extreme whiteness was deliberately avoided. The digital simulation was shared with the patient before placement.",
      },
    },
  ];

  return (
    <main data-testid="results-page">
      <Seo title={t({ tr: "Sonuçlar ve Hasta Deneyimleri", en: "Results and Patient Experiences" })} description={t({ tr: "Mevzuata uygun formatta vaka anlatımları ve izinli hasta deneyimleri.", en: "Regulation-compliant case narratives and consented patient experiences." })} />
      <PageHeader
        tag={{ tr: "Sonuçlar", en: "Results" }}
        title={{ tr: "Süreç anlatımları ve izinli deneyimler", en: "Process narratives and consented experiences" }}
        subtitle={{ tr: "Sağlık mevzuatı gereği öncesi/sonrası fotoğraf yerine, izinli yazılı deneyimler ve süreç anlatımları paylaşıyoruz.", en: "In line with health regulations, we share consented written experiences and process narratives instead of before/after photos." }}
      />
      <section className="max-w-4xl mx-auto px-6 md:px-12 pb-16 space-y-6">
        {cases.map((c, i) => (
          <article key={i} className="rounded-xl glass-card p-8 md:p-10" data-testid={`case-${i}`}>
            <h2 className="font-heading font-semibold text-lg text-[#F2F5F7]">{t(c.title)}</h2>
            <p className="text-sm text-[#94A3AE] mt-3 leading-relaxed">{t(c.story)}</p>
            <SimDisclaimer />
          </article>
        ))}
      </section>
      <section className="max-w-6xl mx-auto px-6 md:px-12 pb-8">
        <h2 className="font-heading text-xl font-semibold text-[#F2F5F7] mb-8">{t({ tr: "Hasta deneyimleri", en: "Patient experiences" })}</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((x, i) => (
            <blockquote key={i} className="rounded-xl glass-card p-7">
              <p className="text-sm text-[#94A3AE] leading-relaxed">"{t(x.text)}"</p>
              <footer className="mt-4 text-xs font-semibold text-[#F2F5F7]">
                {x.name} · <span className="text-[#94A3AE] font-normal">{t(x.place)}</span>
              </footer>
            </blockquote>
          ))}
        </div>
        <div className="mt-12 text-center">
          <CtaLink to="/mirror" testId="results-mirror-cta">{t({ tr: "Kişiye özel değerlendirme isteyin", en: "Request a personal evaluation" })}</CtaLink>
        </div>
      </section>
    </main>
  );
}
